import type { Variant } from '@chessbut/engine';
import { variantDay } from '@chessbut/shared';
import { SITE_URL } from './platform.ts';

/**
 * Wordle-style result block (brand/UI.md):
 *   ChessBut · Day 1 🐌
 *   chess, but snails hunt your king
 *   ✅ won in 31 · +12 → 1535
 *   🔥 5 days
 */
export function resultShareText(opts: {
  variant: Variant;
  outcome: 'win' | 'loss' | 'draw';
  plies: number;
  rating?: { diff: number; after: number } | null;
  streak?: number | null;
  vs?: string;
  grid?: string;
}): string {
  const day = variantDay(opts.variant.id);
  const moves = Math.ceil(opts.plies / 2);
  // "in N" only once there were moves; a game resigned at the start just says won/lost.
  const inMoves = moves > 0 ? ` in ${moves}` : '';
  const verdict = opts.outcome === 'win' ? `✅ won${inMoves}` : opts.outcome === 'loss' ? `❌ lost${inMoves}` : `🤝 drew${inMoves}`;
  const rating = opts.rating ? ` · ${opts.rating.diff >= 0 ? '+' : ''}${opts.rating.diff} → ${opts.rating.after}` : '';
  return [
    `ChessBut${day !== null ? ` · Day ${day}` : ''} ${opts.variant.info.emoji}`,
    `chess, but ${opts.variant.info.but}`,
    `${verdict}${opts.vs ? ` vs ${opts.vs}` : ''}${rating}`,
    opts.grid,
    opts.streak && opts.streak > 1 ? `🔥 ${opts.streak} days` : null,
  ]
    .filter(Boolean)
    .join('\n');
}

export function dayUrl(variant: Variant): string {
  const day = variantDay(variant.id);
  return `${SITE_URL}/${day !== null && day > 0 ? day : variant.id}`;
}
